export const MENSAGEM_PRAZO_ENCERRADO = 'Prazo para confirmação de vagas neste ciclo encerrado.';
export const MENSAGEM_PRAZO_NAO_INICIADO = 'O prazo para confirmação de vagas neste ciclo ainda não foi iniciado.';
